import { Component, Input, } from '@angular/core';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { AccessoryFirstPageModel } from '../../models/accessory-first-page.model';
import AccessoriesService from '../../cart-process/accessories.service';
import { slideInOut } from '../../utils/animations/slides.animation';

@Component({
  selector: '[new-offer-slot-accessory-item]',
  templateUrl: './new-offer-slot-accessory-item.component.html',
  animations: [slideInOut],
})
export default class NewOfferSlotAccessoryItemComponent {
  @Input() accessory: AccessoryFirstPageModel;

  constructor(
    public commonInfo: CommonInfoService,
    public accessoriesService: AccessoriesService
  ) {
  }
}

